<template>
  <header
    class="sticky top-0 z-50 overflow-hidden backdrop-blur-md transition-shadow duration-300"
    :class="scrolled ? 'shadow-lg shadow-black/30' : ''"
    style="background: radial-gradient(120% 200% at 20% 0%, rgba(255,77,24,0.3), rgba(15,13,11,0.92) 60%), rgba(15,13,11,0.92);"
  >
    <!-- Progresso de leitura da página -->
    <div
      class="absolute bottom-0 left-0 h-0.5 w-full origin-left bg-primary-500"
      :style="{ transform: `scaleX(${progress})` }"
      aria-hidden="true"
    ></div>
    <div class="max-w-6xl mx-auto px-5 lg:px-8 h-16 flex items-center justify-between">
      <a href="/" class="flex items-center shrink-0">
        <img :src="logoCompleto" alt="Avance Gestor" class="h-7 w-auto" />
      </a>

      <nav class="hidden md:flex items-center gap-8 text-sm font-medium text-white/60">
        <a href="/#recursos" class="hover:text-white transition-colors">Funcionalidades</a>
        <a href="/#planos" class="hover:text-white transition-colors">Planos</a>
        <a href="/#faq" class="hover:text-white transition-colors">FAQ</a>
        <router-link to="/blog" class="hover:text-white transition-colors">Blog</router-link>
      </nav>

      <div class="flex items-center gap-2 sm:gap-3">
        <a :href="`${appUrl}/login`" class="text-sm font-semibold text-white/80 hover:text-primary-400 transition-colors px-2 sm:px-3" @click="handleLoginClick">
          Entrar
        </a>
        <Button type="button" size="sm" class="whitespace-nowrap" @click="handleCtaClick">
          {{ ctaLabel('Comece agora') }}
        </Button>
      </div>
    </div>
  </header>
</template>

<script setup>
import Button from '../ui/Button.vue'
import { appUrl } from '../../content/landingContent.js'
import { trackEvent } from '../../utils/analytics.js'
import { useSignupModal } from '../../composables/useSignupModal.js'
import logoCompleto from '../../assets/logo-horizontal.svg'

import { useTrialCta } from '../../composables/useTrialCta.js'
import { ref, onMounted, onBeforeUnmount } from 'vue'

const scrolled = ref(false)
const progress = ref(0)

const onScroll = () => {
  const max = document.documentElement.scrollHeight - window.innerHeight
  scrolled.value = window.scrollY > 8
  progress.value = max > 0 ? Math.min(1, window.scrollY / max) : 0
}

onMounted(() => {
  onScroll()
  window.addEventListener('scroll', onScroll, { passive: true })
})
onBeforeUnmount(() => window.removeEventListener('scroll', onScroll))

const { openSignupModal, handleLoginClick } = useSignupModal()
const { ctaLabel } = useTrialCta()

const handleCtaClick = () => {
  trackEvent('cta_click', { placement: 'header' })
  openSignupModal()
}
</script>
